import type { FunctionComponent } from 'react';

import { Widget } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import { PROPS } from './constants';
import useEmploymentInformation from './useEmploymentInformation';
import useHouseholdAnnualIncomeValidation from './useHouseholdAnnualIncomeValidation';

const EmploymentInformation: FunctionComponent = function () {
  const { Fields } = useEmploymentInformation();
  const householdAnnualIncomeValidation = useHouseholdAnnualIncomeValidation();

  return (
    <>
      <Text {...PROPS.title} />
      <Text {...PROPS.description} />
      {Fields && <Fields />}
      <Widget.CreditEmploymentDetailsGrossAnnualIncomeAmount
        {...PROPS.grossAnnualIncome}
      />
      <Widget.CreditEmploymentDetailsHouseholdAnnualIncomeAmount
        {...PROPS.householdAnnualIncome}
        validation={householdAnnualIncomeValidation}
      />
    </>
  );
};

export default EmploymentInformation;
